<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#E1DFD9" fill-opacity="0.7" />
    <rect
      x="1"
      y="1"
      width="30"
      height="30"
      rx="15"
      stroke="#434442"
      stroke-opacity="0.7"
      stroke-width="2"
    />
  </svg>
</template>
